import { createContext, use } from "react";

export const ReadOnlyContext = createContext(false);

export function useIsReadOnly() {
  return use(ReadOnlyContext);
}
